import { ChangeDetectionStrategy, Component} from '@angular/core';
import { KexpTrackInfoComponent } from '../../track-info/track-info.component';
import { TrackCardController } from '../track-card.controller';
import { HngSafeHtmlComponent } from '@hidat/ng-common';

/**
 * A large vertical track information card.
 * Includes a large version of the album artwork, track info, show info, and full comments
 */
@Component({
  selector: 'tall-track-card',
  templateUrl: './tall-track-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    KexpTrackInfoComponent,
    HngSafeHtmlComponent
  ]
})
export class TallTrackCardComponent extends TrackCardController {

}
